export default __webpack_public_path__ + "45409c0540b0a3d3367a4f867dc59c7d.png";